import { Layout } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';
import { Suspense } from 'react';
import ContentSkeleton from '@components/ContentSkeleton';
import { AnimatePresence } from 'framer-motion';
import Header from '@components/layout/Header';
import Footer from '@components/layout/Footer';
import ScrollProgressBar from '@components/ScrollProgressBar';
import '@components/layout/layout.scss';

const { Content } = Layout;

export const MainLayout = () => {
  const location = useLocation();

  return (
    <Layout className="layout">
      <ScrollProgressBar />
      <Header />
      <Content className="main-content">
        <div className="container">
          <AnimatePresence mode="wait">
            <Suspense fallback={<ContentSkeleton type="about" />}>
              <Outlet key={location.pathname} />
            </Suspense>
          </AnimatePresence>
        </div>
      </Content>
      <Footer />
    </Layout>
  );
};

export default MainLayout;